import { QID_APP_USERS, QID_DEVICES, QID_LOCATIONS, QID_SUMMARY } from '@/constants/question-ids'
import { LOCATIONS_OPTIONS } from '../../constants/question-options'

export default [
  {
    questionId: QID_LOCATIONS,
    slug: 'voip-user',
    visibility: {},
    title: 'How many locations would you like to have devices in?',
    subtitle: "Please include business premises and homes. We'll ask you about app users in a moment.",
    type: 'box',
    options: LOCATIONS_OPTIONS,
    drawer: {
      buttonMessage: 'Sounds good',
      buttonIcon: false
    },
    message: {
      type: 'title',
      config: {
        title: 'Great.',
        value: 'We’ll now gather some info on your needs, but you’ll be able to customise it later'
      }
    }
  },
  {
    questionId: QID_DEVICES,
    slug: 'devices',
    visibility: {
      answer: {
        id: 'qid_locations',
        type: 'exclude',
        value: '0'
      }
    },
    title: 'Perfect. Give us an idea of how many devices you might need?',
    subtitle: '',
    skipQuestionMessage: 'Skip this question',
    type: 'imageCounters',
    inlineNextButton: true,
    options: [
      {
        choice: 'Desk phones',
        value: 'deskPhones',
        image: 'assets/images/products/handsets/Cisco_6841-51-61-71.png',
        imageMobile: 'assets/images/products/handsets/Cisco_6841-51-61-71.png',
        theme: 'multiple'
      },
      {
        choice: 'Cordless phones',
        value: 'cordlessPhones',
        image: 'assets/images/products/handsets/Yealink_w52p.png',
        imageMobile: 'assets/images/products/handsets/Yealink_w52p.png',
        theme: 'multiple'
      },
      {
        choice: 'Conference phones',
        value: 'conferencePhones',
        image: 'assets/images/products/handsets/Polycom_8800.png',
        imageMobile: 'assets/images/products/handsets/Polycom_8800.png',
        theme: 'multiple'
      }
    ],
    tracking: {
      class: 'voip-device-selection',
      id: 'voip-device-select-comparison',
      name: 'voip-device-select',
      text: 'See the devices we compare',
      type: 'submit'
    },
    trackingSkipQ: {
      class: 'voip-device-selection',
      id: 'voip-device-select-not-sure',
      name: 'voip-device-select',
      text: 'Im not sure, Ill talk to the expert about it',
      type: 'submit'
    }
  },
  {
    questionId: QID_APP_USERS,
    slug: 'app-users',
    title: 'How many desktop/mobile app users will you need?',
    subtitle: 'Use your cloud phone system on any device. You can customise from a wide range of features later',
    skipQuestionMessage: 'Skip this question',
    type: 'DesktopMobileApp',
    inlineNextButton: true,
    visibility: {},
    option: {
      choice: '',
      value: 'appUsers',
      image: 'assets/images/VoipApp.png',
      imageMobile: 'assets/images/VoipApp.png',
      theme: 'single'
    },
    tracking: {
      class: 'voip-web-app-users',
      id: 'voip-web-app-features',
      name: 'voip-web-app',
      text: 'See the app features',
      type: 'submit'
    },
    trackingSkipQ: {
      class: 'voip-web-app-users',
      id: 'voip-web-app-not-sure',
      name: 'voip-web-app',
      text: 'Im not sure, Ill talk to the expert about it',
      type: 'submit'
    }
  },
  // {
  //   questionId: QID_WHY_COMPARING,
  //   slug: 'voip-comparing',
  //   visibility: {},
  //   title: 'Lastly, why are you comparing digital phone systems today?',
  //   subtitle: '',
  //   type: 'box',
  //   inlineNextButton: true,
  //   options: [
  //     {
  //       choice: 'Replace an old phone system',
  //       value: 'Replace',
  //       tracking: {
  //         class: 'voip-customer-intent',
  //         id: 'voip-intent-replace-system',
  //         name: 'voip-intent',
  //         text: 'Replace an old phone system',
  //         type: 'submit'
  //       }
  //     },
  //     {
  //       choice: 'Upgrade an existing VoIP system',
  //       value: 'Upgrade',
  //       tracking: {
  //         class: 'voip-customer-intent',
  //         id: 'voip-intent-upgrade-system',
  //         name: 'voip-intent',
  //         text: 'Upgrade an existing VoIP system',
  //         type: 'submit'
  //       }
  //     },
  //     {
  //       choice: 'Install a new phone system',
  //       value: 'New Install',
  //       tracking: {
  //         class: 'voip-customer-intent',
  //         id: 'voip-intent-install-new-system',
  //         name: 'voip-intent',
  //         text: 'Install a new phone system',
  //         type: 'submit'
  //       }
  //     },
  //     {
  //       choice: 'Just seeing what’s possible',
  //       value: 'Need Help',
  //       tracking: {
  //         class: 'voip-customer-intent',
  //         id: 'voip-intent-just-looking',
  //         name: 'voip-intent',
  //         text: 'Just seeing what’s possible',
  //         type: 'submit'
  //       }
  //     }
  //   ]
  // },
  {
    questionId: QID_SUMMARY,
    slug: 'summary',
    visibility: {
      existing: true,
      nonExisting: true
    },
    title: 'Perfect!',
    subtitle: 'Your expert will use this info for your initial comparison, but you can customise when you speak to them​.',
    type: 'summary',
    inlineNextButton: true
  }
]
